// Radha — Arabic (ar-AE) — RTL locale pack.
// Shell chrome only: nav, header, repeated states and actions. Panel body
// copy is intentionally absent — it is finance/legal terminology that needs
// native review, and t() falls back to English until it is translated.
const ar = {
  "nav.overview": "نظرة عامة",
  "nav.collections": "التحصيل",
  "nav.disputes": "النزاعات",
  "nav.contracts": "العقود",
  "nav.invoicing": "الفوترة",
  "nav.recurring": "المتكررة",
  "nav.statements": "كشوف الحساب",
  "nav.creditNotes": "إشعارات دائنة",
  "nav.gst": "الضريبة",
  "nav.tax": "الضرائب والفوترة الإلكترونية",
  "nav.reconciliation": "التسوية",
  "nav.deductions": "الخصومات",
  "nav.withholding": "الاستقطاع الضريبي",
  "nav.cashflow": "التدفق النقدي",
  "nav.crm": "إدارة العملاء",
  "nav.forecasts": "التوقعات",
  "nav.reminders": "التذكيرات",
  "nav.dunning": "المطالبة",
  "nav.automation": "الأتمتة",
  "nav.settings": "الإعدادات",
  "nav.privacy": "الخصوصية",
  "group.receivables": "الذمم المدينة",
  "group.planning": "التخطيط",
  "group.operations": "العمليات",
  "group.admin": "الإدارة",
  "app.tagline": "نظام تشغيل الإيرادات",
  "app.signOut": "تسجيل الخروج",
  "app.search": "بحث",
  "app.toggleTheme": "تبديل النمط اللوني",
  "app.toggleNav": "إظهار التنقل",
  "app.language": "اللغة",
  "app.useTenantDefault": "استخدام الإعداد الافتراضي",
  "state.loading": "جارٍ التحميل…",
  "state.error": "تعذّر تحميل البيانات",
  "state.empty": "لا يوجد شيء بعد",
  "state.readOnly": "للقراءة فقط",
  "action.approve": "اعتماد",
  "action.reject": "رفض",
  "action.save": "حفظ",
  "action.saving": "جارٍ الحفظ…",
  "action.saved": "تم الحفظ",
  "action.cancel": "إلغاء",
  "action.export": "تصدير إلى Excel",
};
export default ar;
